<template>
  <div>
    <div id="experience-table">
      <table class="table table-hover ui-table mb-4 mt-2">
        <thead>
          <tr>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.date_from'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.date_to'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.institution'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.main_program'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.sub_program'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.subject'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.level'
                )
              }}
            </th>
            <th style="width: 3%" class="text-center">
              <a href="#" @click.prevent="addNewRow">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(experience, index) in teacher_experience_list"
            :key="index"
          >
            <td style="width: 12%">
              <a-date-picker
                v-model="experience.from_date"
                valueFormat="DD-MM-YYYY"
                format="DD-MM-YYYY"
                class="ts-w-full"
              />
              <div
                class="validate"
                v-if="
                  errors.has('teacher_experience_list.' + index + '.from_date')
                "
              >
                {{
                  errors.first(
                    'teacher_experience_list.' + index + '.from_date'
                  )
                }}
              </div>
            </td>
            <td style="width: 12%">
              <a-date-picker
                v-model="experience.to_date"
                valueFormat="DD-MM-YYYY"
                format="DD-MM-YYYY"
                class="ts-w-full"
              />
              <div
                class="validate"
                v-if="
                  errors.has('teacher_experience_list.' + index + '.to_date')
                "
              >
                {{
                  errors.first('teacher_experience_list.' + index + '.to_date')
                }}
              </div>
            </td>
            <td>
              <a-input
                type="text"
                v-model.trim="experience.institution"
                class="ts-w-full"
              />
              <div
                class="ts-text-red-500"
                v-if="
                  errors.has(
                    'teacher_experience_list.' + index + '.institution'
                  )
                "
              >
                {{
                  errors.first(
                    'teacher_experience_list.' + index + '.institution'
                  )
                }}
              </div>
            </td>
            <td>
              <a-select
                v-model="experience.acp_id"
                :options="mainProgramList"
                @change="onMainProgramChange(experience)"
                :showSearch="true"
                :filterOption="filterOption"
                style="min-width: 200px;"
                class="ts-w-full"
              ></a-select>
              <div
                class="ts-text-red-500"
                v-if="
                  errors.has('teacher_experience_list.' + index + '.acp_id')
                "
              >
                {{
                  errors.first('teacher_experience_list.' + index + '.acp_id')
                }}
              </div>
            </td>
            <td>
              <a-select
                v-model="experience.acps_id"
                :options="subProgramList(experience.acp_id)"
                @change="onSubProgramChange(experience)"
                :showSearch="true"
                :filterOption="filterOption"
                style="min-width: 200px;"
                class="ts-w-full"
              ></a-select>
              <div
                class="ts-text-red-500"
                v-if="
                  errors.has('teacher_experience_list.' + index + '.acps_id')
                "
              >
                {{
                  errors.first('teacher_experience_list.' + index + '.acps_id')
                }}
              </div>
            </td>
            <td>
              <a-select
                v-model="experience.subject_id"
                :options="
                  subjectList(experience.acps_id, experience.subject_id)
                "
                :showSearch="true"
                :filterOption="filterOption"
                style="min-width: 200px;"
                class="ts-w-full"
              ></a-select>
              <div
                class="ts-text-red-500"
                v-if="
                  errors.has('teacher_experience_list.' + index + '.subject_id')
                "
              >
                {{
                  errors.first(
                    'teacher_experience_list.' + index + '.subject_id'
                  )
                }}
              </div>
            </td>
            <td>
              <a-select
                v-model="experience.level_id"
                style="min-width: 100px;"
                class="ts-w-full"
                :options="[
                  {
                    value: 1,
                    label: $t('teacherprofile.level1')
                  },
                  {
                    value: 2,
                    label: $t('teacherprofile.level2')
                  },
                  {
                    value: 3,
                    label: $t('teacherprofile.level3')
                  }
                ]"
              ></a-select>
              <div
                class="ts-text-red-500"
                v-if="
                  errors.has('teacher_experience_list.' + index + '.level_id')
                "
              >
                {{
                  errors.first('teacher_experience_list.' + index + '.level_id')
                }}
              </div>
            </td>
            <td>
              <a
                href="#"
                class="text-danger"
                @click.prevent="removeRow(experience)"
              >
                <i class="fa fa-trash mt-2"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'experience',
  props: ['value', 'validate'],
  data() {
    return {
      teacher_experience_list: [],
      newRow: {
        institution: '',
        subject_id: '',
        level_id: '',
        from_date: '',
        to_date: '',
        acp_id: '',
        acps_id: ''
      },
      errors: new Errors()
    }
  },
  computed: {
    ...mapState('teacherProfile', ['main_programs', 'edit_data']),
    ...mapGetters('teacherProfile', ['getSubPrograms', 'getSubject']),
    mainProgramList() {
      return this.main_programs.map(el => ({
        value: el.acp_id,
        label: el.acp_name_foreign
      }))
    },
    subProgramList: vm => apcId => {
      const sub = vm.getSubPrograms(apcId)
      if (sub.length) {
        return sub.map(el => ({
          value: el.acps_id,
          label: el.acps_name_foreign
        }))
      }
      return []
    },
    subjectList: vm => (apcsId, subjectId) => {
      const subjects = vm.getSubject(apcsId)
      const excludeSubject = vm.teacher_experience_list
        .filter(el => el.subject_id !== subjectId)
        .map(el => el.subject_id)

      if (subjects.length) {
        return subjects
          .filter(el => !excludeSubject.includes(el.subject_id))
          .map(el => ({
            value: el.subject_id,
            label: el.subject_name_foreign
          }))
      }
      return []
    }
  },
  created() {
    this.teacher_experience_list = this.value
  },
  methods: {
    addNewRow() {
      this.teacher_experience_list.push(Object.assign({}, this.newRow))
    },
    removeRow(row) {
      this.teacher_experience_list.splice(
        this.teacher_experience_list.indexOf(row),
        1
      )
    },
    onMainProgramChange(experience) {
      experience.acps_id = ''
      experience.subject_id = ''
      experience.level_id = ''
      this.$store
        .dispatch('teacherProfile/subProgram', experience.acp_id)
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    onSubProgramChange(experience) {
      experience.subject_id = ''
      experience.level_id = ''
      this.$store
        .dispatch('teacherProfile/subject', {
          acps_id: experience.acps_id,
          is_appear_other_company: false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    }
  },
  watch: {
    value: {
      handler() {
        this.teacher_experience_list = this.value
      }
    },
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    },
    edit_data: {
      handler() {
        if (!_.isEmpty(this.edit_data)) {
          this.edit_data.experiences.map(async el => {
            await this.onMainProgramChange(el)
            await this.onSubProgramChange(el)
          })
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="css" scoped>
#experience-table {
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
#experience-table::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
#experience-table::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
